import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Morphext } from 'src/shared/components';

import styles from './HomeText.module.scss';

const HomeText = () => {
	const { t } = useTranslation();

	const solutionsPhrases = [
		t('homeSection.solutionsPhrases.software'),
		t('homeSection.solutionsPhrases.innovative'),
		t('homeSection.solutionsPhrases.efficient'),
		t('homeSection.solutionsPhrases.intelligent')
	];

	return (
		<Fragment>
			<h1 className={styles.title}>{t('homeSection.welcome')}</h1>
			<h2 className={styles.text}>
				{t('homeSection.weCreate')}{' '}
				<span className={styles.rotatingText}>
					{t('homeSection.solutions')} <Morphext animation="flipInX" speed={3000} phrases={solutionsPhrases} />
				</span>{' '}
				{t('homeSection.toStrengthen')}
			</h2>
		</Fragment>
	);
};

export default HomeText;
